import styled from 'styled-components';
import { StyledTable as MatrixStyledTable } from '../MatrixModel/styles';

export const StyledColorPickerCell = styled.td`
  && {
    padding: 0;
  }
`;

export const StyledTable = styled(MatrixStyledTable)`
  /* Override width to match bullet chart width */
  width: 100%;

  /* CHANGED from MatrixModel: We don't have a header row, so don't apply gray to all cells in first row */
  /* MatrixModel: tr:first-child td { background-color: var(--cl-gray-200); } */
  tr:first-child td {
    background-color: transparent;
    border: 1px solid var(--cl-gray-300);
    border-right: 1px solid var(--cl-gray-300);
  }

  /* Override matrix model styling for first cell */
  tr:first-child td:first-child {
    background-color: var(--cl-gray-200);
    border: none;
    border-bottom: 1px solid var(--cl-gray-300);
  }

  /* Style first column to match editable table styling */
  tbody > tr > td:nth-of-type(1) {
    border-bottom: 1px solid var(--cl-gray-300);
    background-color: var(--cl-gray-200);
    padding-right: var(--cl-space-4);
    text-align: right;
  }
`;

